import { primeiraMaiuscula } from '@/lib/texto';

import { ErroDaApi } from './api';

/**
 * A recusa do servidor, escrita como o manual pede: o que aconteceu e o que
 * fazer em seguida (regra 10 do checklist, p.25).
 *
 * As duas metades chegam prontas do backend — `{ erro, comoResolver }` — e
 * incluem as recusas do BANCO ja traduzidas: periodo sobreposto, status fora
 * dos seis, codigo repetido, referencia a cadastro de outra empresa. Reescrever
 * a frase aqui seria criar uma segunda versao da mesma mensagem para divergir
 * na primeira mudanca.
 *
 * Sem ponto de exclamacao e sem emoji, como o manual manda em toda mensagem do
 * sistema.
 */
export function MensagemDeErro({ erro }: { readonly erro: unknown }) {
  if (!erro) return null;

  const daApi = erro instanceof ErroDaApi ? erro : null;
  /* `primeiraMaiuscula` porque o servidor escreve `erro` em minuscula — e sem
     ela as mensagens deste modulo chegavam a tela comecando em minuscula
     enquanto as dos modulos 01 e 08 chegavam certas, na mesma aplicacao. */
  const titulo = daApi ? primeiraMaiuscula(daApi.message) : 'Não foi possível concluir';
  const comoResolver =
    daApi?.comoResolver ?? 'Tente de novo; se continuar, avise o suporte com o horário em que aconteceu.';

  return (
    <div
      role="alert"
      className="bloco-rebaixado flex flex-col gap-1 p-3"
    >
      <span className="txt-corpo text-tinta">{titulo}</span>
      <span className="txt-apoio text-tinta-secundaria">{comoResolver}</span>
    </div>
  );
}
